export default __webpack_public_path__ + "static/media/experiencen.ac0b6845.jpeg";